import Loadable from '../../components/loadable';

const ContactNotes = Loadable({
  loader: () => import('../../pages/contacts/notes'),
  type: 'block',
});

angular.module('gym').value('ContactNotes', ContactNotes);
